import React from "react";
import { PageContainer } from "../../components/Common/PageContainer";
import List from "./list";

const Main = () => {
	return <PageContainer title="Yet to be Released" subtitle="Yet to be Released" icon="mdi mdi-information" component={(props) => <List {...props} />} />;
};

export default Main;
